import QueryBuilderEdit from "../pages/QueryBuilderEditPage.vue";

const routes = [{ name: "QueryBuilderEdit", path: "/querybuilder", component: QueryBuilderEdit, meta: { title: "Query Builder Edit" } }];
export default routes;
